import React, { Component } from 'react';
import { Col, Row } from 'reactstrap';

import AppRoutes from '../../config/AppRoutes';
import CustomButton from '../Button/CustomButton';
import CustomCard from '../CustomCard';
import CardBody from '../CustomCard/CardBody';
import CardHeader from '../CustomCard/CardHeader';
import Header from '../Header';
import LoaderWrapper from '../LoaderWrapper';
import Question from '../QuestionBank/Question';
import ReportQuestion from '../QuestionBank/ReportQuestion';
import Report from '../Report';
import { cbtColor } from '../common';
import {
  flagUnFlagSelectedQuestion,
  getMockDetailsById,
  getUserStatsByTestId,
  mockQuestions,
  saveMockUserChoice,
} from '../services';
import FinishPageRightSidebar from './FinishPageRightSidebar';
import ShowAnswer from './ShowAnswer';
import SidebarIndex from './SidebarIndex';
import Summary from './Summary';
export default class CBTFinishPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questionData: [],
      strikeThroughArr: [],
      flaggedQuesObject: {},
      attemptedQuesObject: {},
      showSectionReview: false,
      isLoading: true,
      title: '',
      showAnswer: true,
      showReportSection: false,
      showSummary: false,
      score: 0,
    };
    this.slider = '';
  }

  static contextTypes = { router: React.PropTypes.object };

  componentDidMount() {
    window.scrollTo(0, 0);
    const {
      chapterId,
      params: { mockId, testId },
    } = this.props;
    const data = {
      chapterId,
      mock_id: isNaN(mockId) ? 1 : parseInt(mockId, 10),
      test_id: isNaN(testId) ? 1 : parseInt(testId, 10),
    };

    this.fetchQuestionByMock(data);
    this.fetchUserRecordByTestId(data);
    this.getTitle(data);
  }

  fetchQuestionByMock = async data => {
    const response = await mockQuestions(data);
    if (response.success) {
      this.setState({ questionData: response.question, questionIds: response.questionIds });
      const {
        location: { pathname },
        params: { offset },
      } = this.props;
      if (pathname.includes(':questionId'))
        this.context.router.push({
          pathname: pathname.replace(':questionId', response.question[offset].id),
          state: {},
        });
    }
    this.setState({ isLoading: false });
  };

  handleCallback = childData => {
    this.slider = childData.slider;
  };

  getTitle = async data => {
    const response = await getMockDetailsById({ mockId: data.mock_id });
    if (response.success) {
      this.setState({ title: response.mockData.mock_exam });
    }
  };
  fetchUserRecordByTestId = async data => {
    const response = await getUserStatsByTestId(data);
    if (response.success) {
      const { questions = {}, flagged_questions = {} } = response.userStatsData;
      const { questionId } = this.props.params;

      const attemptedQuesObjectFromRes = questions ? JSON.parse(questions) : {};
      this.setState({
        attemptedQuesObject: attemptedQuesObjectFromRes,
        selectedChoice: attemptedQuesObjectFromRes[questionId] || '',
        flaggedQuesObject: flagged_questions ? JSON.parse(flagged_questions) : {},
      });
    }
  };

  getQuestionIDfromOffset = (offset = 0) => {
    const { questionData } = this.state;
    let parsedOffset = parseInt(offset, 10);
    if (isNaN(parsedOffset)) parsedOffset = 0;
    return questionData[offset].id;
  };

  setAnswer = async ([UserAnswer]) => {
    const { attemptedQuesObject } = this.state;
    const { offset, testId, mockId } = this.props.params;
    const questionId = this.getQuestionIDfromOffset(offset);
    attemptedQuesObject[questionId] = UserAnswer;
    this.setState({
      selectedChoice: UserAnswer,
      attemptedQuesObject,
    });
    // Calling API to set answer
    await saveMockUserChoice({
      choice: UserAnswer,
      test_id: testId,
      mock_id: mockId,
      index: offset,
      question_id: questionId,
    });
  };

  strikeText = (event, [value]) => {
    event.preventDefault();
    const { strikeThroughArr } = this.state;
    this.setState({ strikeThroughArr: this.toggleArray(strikeThroughArr, value) });
  };

  toggleArray = (array, value) => {
    const choiceIndex = array.findIndex(element => element === value);
    if (choiceIndex === -1) {
      array.push(value);
    } else {
      array.splice(choiceIndex, 1);
    }
    return array;
  };

  onFlagClick = offset => {
    const { flaggedQuesObject } = this.state;
    const { mockId, testId } = this.props.params;
    const questionId = this.getQuestionIDfromOffset(offset);
    if (flaggedQuesObject[questionId]) {
      delete flaggedQuesObject[questionId];
    } else {
      flaggedQuesObject[questionId] = 'flagged';
    }
    flagUnFlagSelectedQuestion({
      flaggedQuestions: flaggedQuesObject,
      testId,
      mockId,
    });

    this.setState({ flaggedQuesObject });
  };

  changeQuestionByIndex = inputIndex => {
    let index = inputIndex;
    if (isNaN(index)) index = 0;
    const { mockId, testId, isNegative, timerStart, timer } = this.props.params;
    const { attemptedQuesObject } = this.state;
    const questionId = this.getQuestionIDfromOffset(index);

    this.slider.slickGoTo(index);
    this.context.router.push({
      pathname: AppRoutes.ESG_CBT_FINISH_PAGE.replace(':offset', index)
        .replace(':mockId', mockId)
        .replace(':questionId', questionId)
        .replace(':testId', testId)
        .replace(':isNegative', isNegative)
        .replace(':timerStart', timerStart)
        .replace(':timer', timer),
    });

    this.setState({ selectedChoice: attemptedQuesObject[questionId] || '' });
  };

  onClickPreviousButton = offset => {
    this.changeQuestionByIndex(offset - 1);
  };
  onClickNextButton = offset => {
    this.changeQuestionByIndex(offset + 1);
  };
  navigateToAttemptedMockList = () => {
    const { mockId, timer } = this.props.params;
    this.context.router.push({
      pathname: AppRoutes.ESG_CBT_VIEW_ATTEMPTED_MOCK.replace(':id', mockId).replace(':timer', timer),
      state: {},
    });
  };

  getScore = score => {
    this.setState({ score });
  };

  render() {
    const {
      questionData,
      // selectedChoice,
      strikeThroughArr,
      attemptedQuesObject,
      showReportSection,
      flaggedQuesObject,
      isLoading,
      title,
      showAnswer,
      showSummary,
      score,
      questionIds,
    } = this.state;
    let { offset = 0 } = this.props.params;
    const { questionId, mockId, testId, timer } = this.props.params;

    offset = parseInt(offset, 10);
    if (isNaN(offset)) offset = 0;

    let questionObject = {};
    try {
      if (questionData.length) {
        questionObject = questionData[offset];
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.trace(error);
    }
    let totalQuestions = 0;

    if (Array.isArray(questionIds) && questionIds.length > 0) {
      totalQuestions = questionIds.length;
    } else if (Array.isArray(questionData) && questionData.length > 0) {
      totalQuestions = questionData.length;
    }
    return (
      <LoaderWrapper isLoading={isLoading}>
        <div>
          <div className='animated fadeIn'>
            <Header title={title}>
              <CustomButton className={'back-btn'} onClick={this.navigateToAttemptedMockList}>
                Back
              </CustomButton>
            </Header>
            <div className='d-flex font-16px'>
              <SidebarIndex
                itemArray={questionData}
                currentIndex={offset}
                slidesToShow={10}
                onClick={this.changeQuestionByIndex}
                initialSlide={offset}
                flaggedQuesObject={flaggedQuesObject}
                attemptedQuesObject={attemptedQuesObject}
                finishPage={true}
                parentCallback={this.handleCallback}
              />
              <div className='ques-detail-wrapper'>
                <CustomCard className='w-100'>
                  <CardHeader
                    headerImage='/img/question_bank/question_icon_blue.svg'
                    headingText={`Q.${parseInt(offset, 10) + 1}`}
                    // headerClassName='pl-0'
                  >
                    <CustomButton
                      onClick={() => {
                        this.setState({ showSummary: true });
                      }}
                    >
                      Summary
                    </CustomButton>
                    <CustomButton
                      onClick={() => {
                        this.context.router.push({
                          pathname: AppRoutes.ESG_CBT_DETAILED_STATS_GRAPH.replace(':id', mockId)
                            .replace(':testId', testId)
                            .replace(':totalQuestions', questionData.length)
                            .replace(':totalMarks', questionData.length)
                            .replace(':timer', timer),
                        });
                      }}
                      disabled={!Boolean(+score)}
                    >
                      Detailed Score
                    </CustomButton>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col md={9} xs={12}>
                        {questionData.length && (
                          <Question
                            {...questionObject}
                            setAnswer={this.setAnswer}
                            selectedChoiceClassName='border-yellow'
                            correctChoiceClassName={cbtColor.correct.className}
                            incorrectChoiceClassName={cbtColor.incorrect.className}
                            strikeText={this.strikeText}
                            strikeThroughArr={strikeThroughArr}
                            showAnswer={showAnswer}
                            selectedChoice={attemptedQuesObject[questionObject.id]}
                            correctChoice={questionObject.correct_choice}
                          />
                        )}
                      </Col>
                      <FinishPageRightSidebar
                        className='mt-2 col-sm-4 col-lg-3'
                        {...this.props}
                        totalQuestions={totalQuestions}
                        getScore={this.getScore}
                      />

                      <Col md={12} xs={12} className='text-right mt-2'>
                        <div className='d-flex justify-content-end'>
                          <ReportQuestion
                            className='mr-1'
                            onClick={() => this.setState({ showReportSection: true })}
                          />
                          <CustomButton
                            className='mid-btn'
                            onClick={() => this.onClickPreviousButton(parseInt(offset, 10))}
                            disabled={parseInt(offset, 10) === 0}
                          >
                            <i className='fa fa-angle-left' /> <span>Back</span>
                          </CustomButton>
                          <CustomButton
                            className='mid-btn'
                            onClick={() => this.onClickNextButton(parseInt(offset, 10))}
                            disabled={parseInt(offset, 10) === questionData.length - 1}
                          >
                            <span>Next</span> <i className='fa fa-angle-right' />
                          </CustomButton>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </CustomCard>
              </div>
            </div>

            {/* ========= Show Answer  ========================*/}
            {showAnswer && (
              <ShowAnswer {...questionObject} attemptedQuesObject={attemptedQuesObject} />
            )}
            {showReportSection && (
              <Report
                hideReportSection={() => {
                  this.setState({ showReportSection: false });
                }}
                section='CBT'
                mockData={{ mock_id: mockId, timer, testId }}
                commentOnWhichId={questionId}
              />
            )}
            {showSummary && (
              <Summary
                onClose={() => this.setState({ showSummary: false })}
                mockId={mockId}
                testId={testId}
              />
            )}
          </div>
        </div>
      </LoaderWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ESG/CBT/CBTFinishPage.jsx